(function() {
    var localOptTemplate = '<option value="{{code}}">{{codeName}}</option>';
    var topicTmpl = 
       '{{#each (item, index) in topicList}}' +
           '<li>' +
               '<span class="rdo-wrap btn-type4">' +
                   '{{# if (index == 0) { #}}' +
                   '<input type="radio" name="sympCd" id="topic{{index}}" value="{{item.value}}" data-topic-name="{{item.name}}" data-error-msg="정확한 제품 증상을 선택해 주세요." data-required="true" required>' +
                   '{{# } else { #}}' +
                   '<input type="radio" name="sympCd" id="topic{{index}}" value="{{item.value}}" data-topic-name="{{item.name}}">' +
                   '{{# } #}}' +
                   '<label for="topic{{index}}"><span>{{item.name}}</span></label>' +
               '</span>' +
           '</li>' + 
           '{{/each}}';
    var subTopicTmpl = 
       '{{#each (item, index) in subTopicList}}' +
       '<li>' +
             '<span class="rdo-wrap">' +
                '{{# if (index == 0) { #}}' +
                '<input type="radio" name="subTopic" id="subTopic{{index}}" value="{{item.value}}" data-sub-topic-name="{{item.name}}" data-error-msg="정확한 세부 증상을 선택해 주세요." data-required="true" required>' +
                '{{# } else { #}}' +
                '<input type="radio" name="subTopic" id="subTopic{{index}}" value="{{item.value}}" data-sub-topic-name="{{item.name}}">' +
                '{{# } #}}' +
                '<label for="subTopic{{index}}">{{item.name}}</label>' +
             '</span>' +
       '</li>' +
       '{{/each}}';
    var engineerTmpl =
       '{{#each (item, index) in engineerList}}' +
       '<li class="chk-wrap">' +
             '{{# if (index == 0) { #}}' +
                '<input type="radio" name="engineer" id="engineer{{index}}" data-engineer-name="{{item.engineerName}}" data-engineer-code="{{item.engineerCode}}" data-center-name="{{item.centerName}}" data-center-code="{{item.centerCode}}" data-image="{{item.image}}" data-resrv-seq="{{item.resrvSeq}}" value="{{index}}" checked>' +
             '{{# } else { #}}' +
                '<input type="radio" name="engineer" id="engineer{{index}}" data-engineer-name="{{item.engineerName}}" data-engineer-code="{{item.engineerCode}}" data-center-name="{{item.centerName}}" data-center-code="{{item.centerCode}}" data-image="{{item.image}}" data-resrv-seq="{{item.resrvSeq}}" value="{{index}}">' +
             '{{# } #}}' +
             '<label for="engineer{{index}}">' +
                '<span>{{item.engineerName}}</span>' +
                '<span>{{item.centerName}}</span>' +
             '</label>' +
       '</li>' +
       '{{/each}}';
   var sub1TopicTmpl = 
       '<option value="" name="sympSubCode" class="placeholder">증상을 선택해 주세요</option>' +
       '{{#each (item, index) in subTopicList}}' +
          '<option value="{{item.value}}" name="sympSubCode">{{item.name}}</option>' +
       '{{/each}}';

   var sub2TopicTmpl = 
      '<option value="" name="sympCodeThree" class="placeholder">세부 증상을 선택해 주세요</option>' +
      '{{#each (item, index) in threeTopicList}}' +
         '<option value="{{item.value}}" name="sympCodeThree">{{item.name}}</option>' +
      '{{/each}}';
    
   var centerTmpl = '<li data-id="{{shopID}}" deptCode="{{deptCode}}">'+
   					'{{# if (typeof fastDt != "undefined") { #}}'+
                    '<a href="" class="center-info">'+
                    '{{# } else { #}}' +
                    '<a class="center-info" disabled="disabled">'+
                    '{{# } #}}'+
                        '<strong class="center-info-name">{{shopName}}</strong>'+
                        '{{# if (typeof distance != "undefined") { #}}'+
                        '<span class="center-info-distance">{{distance}}km</span>'+
                        '{{# } #}}'+
                       '<p class="center-info-address">{{shopAdress}}</p>'+
                       '{{# if (typeof fastDt != "undefined") { #}}'+
                       '<p class="fastdt-txt"><em>가장 빠른 방문 : {{fastDt}}</em></p>'+
                       '{{# } else { #}}' +
						// BTOCSITE-66068 고객지원 > 센터방문예약> 안내문구 추가 및 팝업 삭제요청
                       '<p class="fastdt-txt">[방문 예약 마감] 예약 없이 방문하셔도 접수가 가능합니다.</p>'+
                       '{{# } #}}'+
                    '</a>'+
                       '<div class="btn-box">'+
                       '<a href="{{shopID}}" class="btn-link" title="새창으로 열림 - {{shopName}}">센터 상세정보</a>'+
                       '{{# if (typeof fastDt != "undefined") { #}}'+
                       '<button type="button" data-shop-id="{{shopID}}" data-shop-name="{{shopName}}" class="btn border">방문예약</button>' +
                       '{{# } else { #}}' +
                       '<button type="button" disabled="disabled" data-shop-id="{{shopID}}" data-shop-name="{{shopName}}" class="btn border">방문예약</button>' +
                       '{{# } #}}'+
                    '</div>'+
                    '</li>';
                    
    var centerTmpl2 = '{{#each (item, index) in listData}}' +
                        '{{# if (typeof item.resrvDt != "undefined") { #}}'+
                        '<li data-id="{{item.shopID}}" deptCode="{{item.deptCode}}">'+
                            '<a href="" class="center-info">'+
                        '{{# } else { #}}' +
                        '<li data-id="{{item.shopID}}" deptCode="{{item.deptCode}}" style="display:none;">'+
                            '<a class="center-info" disabled="disabled">'+
                        '{{# } #}}'+
                            '<strong class="center-info-name">{{item.shopName}}</strong>'+
                            '{{# if (typeof distance != "undefined") { #}}'+
                            '<span class="center-info-distance">{{item.distance}}km</span>'+
                            '{{# } #}}'+
                        '<p class="center-info-address">{{item.shopAdress}}</p>'+
                        '{{# if (typeof item.resrvDt != "undefined") { #}}'+
                            '<p class="fastdt-txt"><em>가장 빠른 방문 : {{item.resrvDt.substring(0,4)}}년 {{item.resrvDt.substring(4,6)}}월 {{item.resrvDt.substring(6,8)}}일 {{item.resrvHm.substring(0,2)}}시</em></p>'+
                        '{{# } else { #}}' +
                            // BTOCSITE-66068 고객지원 > 센터방문예약> 안내문구 추가 및 팝업 삭제요청
                            '<p class="fastdt-txt">[방문 예약 마감] 예약 없이 방문하셔도 접수가 가능합니다.</p>'+
                        '{{# } #}}'+
                        '</a>'+
                        '<div class="btn-box">'+
                        '<a href="{{item.shopID}}" class="btn-link" title="새창으로 열림 - {{item.shopName}}">센터 상세정보</a>'+
                        '{{# if (typeof item.resrvDt != "undefined") { #}}'+
                            '<button type="button" data-shop-id="{{item.shopID}}" data-shop-name="{{item.shopName}}" class="btn border">방문예약</button>' +
                        '{{# } else { #}}' +
                            '<button type="button" disabled="disabled" data-shop-id="{{item.shopID}}" data-shop-name="{{item.shopName}}" class="btn border">방문예약</button>' +
                        '{{# } #}}'+
                        '</div>'+
                        '</li>'+
                    '{{/each}}';



    
    var dateUtil = vcui.date;
    var detect = vcui.detect;
    var isMobile = detect.isMobile;
    var isLogin = lgkorUI.isLogin;
    var cookie = lgkorUI.cookie;
    var validation;
    var authManager;
    var naverMap;

    var reservation = {
        init: function() {
            var self = this;
            
            self.$cont = $('.contents');
            self.$myModelWrap = self.$cont.find('.my-product-wrap');
            self.$prodWrap = self.$cont.find('.prod-wrap');
            self.$searchModelWrap = self.$cont.find('.prod-search-wrap');

            self.$submitForm = self.$cont.find('#submitForm');
            self.$completeBtns = self.$cont.find('#agreeToTerms .btn-group'); // 센터 찾기
            self.$stepArea = self.$cont.find('.step-area');
            self.$stepModel = self.$cont.find('#stepModel');
            self.$stepCenter = self.$cont.find('#stepMap');
            //self.$stepDate = self.$cont.find('#stepDate');
            self.$stepDate = self.$cont.find('#changDT');
            self.$stepInput = self.$cont.find('#stepInput');
            
			//보유재품에서선택, 제품목록에서 선택 탭바
			self.$tabWrap = self.$cont.find('#tabs-prod');
            
            // BTOCSITE-62364 모델번호, 제조번호 입력
            self.$modelSearchBox = self.$searchModelWrap.find('#modelSearchBox'); // 모델명/제조번호 입력
            self.$modelSelectBox = self.$searchModelWrap.find('#modelSelectBox'); // 제품군 선택 
            // 선택 제품 플로팅바
            self.$selectedModelBar = self.$cont.find('.goods-selected-wrap');

            self.$topicBox = self.$stepInput.find('#topicBox');
            self.$topicListWrap = self.$topicBox.find('#topicList');
            self.$topicList = self.$topicListWrap.find('.rdo-list');
            
            self.$saleInfoBox = self.$stepArea.find('#saleInfo');
            self.$productProblemsBox = self.$stepArea.find('#productProblems');
            self.$textarea = self.$productProblemsBox.find('#addDesc textarea');
            self.$userInfoBox = self.$stepArea.find('#userInfo');

            self.$salesDtWrap = self.$saleInfoBox.find('#salesDt');

            self.$subTopicWrap = self.$topicListWrap.find('.sub-topic');

            self.$sub1TopicBox = self.$stepInput.find('#stopic01');
            self.$sub1TopicSelect = self.$stepInput.find('#sTopic01Select');

            self.$sub2TopicBox = self.$stepInput.find('#stopic02');
            self.$sub2TopicSelect = self.$stepInput.find('#sTopic02Select');

            
            self.warrantyGuide = $('#ratesWarrantyGuidePopup');
        
            self.$modelBox = self.$searchModelWrap.find('#model-box');
            
            // 희망날짜
            self.$dateWrap = self.$stepDate.find('.date-wrap');
            self.$timeWrap = self.$stepDate.find('.time-wrap-new');

            // 엔지니어
            self.$engineerResult = self.$cont.find('.engineer-to-visit');
            self.$engineerOpener = $('[data-href="#choiceEngineerPopup"]');
            self.$engineerPopup = $('#choiceEngineerPopup');

            self.$engineerSlider = self.$engineerPopup.find('.engineer-popup');
            self.$solutionsBanner = self.$stepInput.find('#solutionBanner');
            self.$solutionsPopup = $('#solutionsPopup');

            // 본인인증
            self.$authPopup = $('#certificationPopup');
            
            self.resultUrl = self.$searchModelWrap.data('resultUrl');//"commonModelSelected.lgajax?typeFlag=businessFlag";
            self.userAdressCheckedUrl = self.$stepCenter.data('userAdressCheckedUrl');
            self.detailUrl = self.$stepCenter.data('detailUrl');
            //self.dateUrl = self.$stepDate.data('dateUrl');
            self.dateUrl = "/support/reserve/possibleReserveDate";
            self.timeUrl = "/support/reserve/possibleReserveSchedule.lgajax";
            self.engineerUrl = self.$stepInput.data('engineerUrl');
            
            self.centerUrl = self.$stepCenter.data('centerUrl');
            //self.localUrl = self.$stepCenter.data('localListUrl');
            self.localUrl = "/support/center/selectComboList.lgajax";
            self.subwayUrl = self.$stepCenter.data('subwayListUrl');
            self.stationUrl = self.$stepCenter.data('stationListUrl');
            
            //지역검색 관련
            self.area = $('#tab-1');
            self.localGu = $('#mapSelect2');
            self.localSi = $('#mapSelect1');
            self.localSearchButton = self.area.find('.btn.search-local');
            
            //검색
            self.searcharea = $('#tab-2');
            self.searchkeyword = self.searcharea.find('#keyword'); 
            self.searchbtn = self.searcharea.find('.btn-st-search');
            
            self.$keywordWrap = self.searcharea.find('.ui_search');
            
            //지하철역으로 검색
            self.$subwayCitySelect = $('#subwayLocal');
            self.$subwayLineSelect = $('#subwayLine');
            self.$subwayStationSelect = $('#subwayStation');
            self.$searchSubwayButton = $('.search-subway');

            self.$seqTab = self.$cont.find('#seqTab');
            self.$dirTab = self.$cont.find('#dirTab');
            //self.fastItmeconfom = $('#fastTimeArea');
                                    
            //self.fastItmeconfombtn = self.fastItmeconfom.find('.step-btn-wrap.btn-group.center.type-footer');
            
            self.$searchCurrentButton = $('.search-current');  //내위치 찾기
            self.$searchUserAdressButton = $('.search-address');  //내주소 찾기
            
            //완료
            self.comlpit = $('#btngroup');
            
            self.centerList = self.$stepCenter.find('.center-result-wrap');
            
            self.searchType = 'user';
            
            self.$productProblemsBox.find('#content').attr('placeholder','서비스매니저에게 전달할 내용을 입력해 주세요.\n - 증상이 여러 개일 경우, 선택하신 대표 증상 외의 추가 상황을 이곳에 작성해 주세요.\n ※ 개인 정보를 입력하지 않도록 유의해 주세요. (전화번호, 주소 등)');

            // BTOCSITE-50788 고객지원] 서비스 메뉴 회원/로그인 정책 확대
            if (!lgkorUI.isLogin) {
                $('#loginEnterPopup').vcModal();
            }
            $('.loginPopup').find('.ui_modal_close').on('click', function(){
                $(window).trigger("toastshow", '고객지원 홈으로 이동합니다.');
                
                setTimeout(function(){
                    location.href = "/support";
                }, 100);
            });

            //BTOCSITE-80487 고객지원 > 출장예약 > 모델명 입력 > 자동완성 미선택
            if(lgkorUI.getParameterByName('mpFlag') == 'Y'){
                self.$tabWrap.vcTab('select', 1);
            }

            var seq = lgkorUI.searchParamsToObject('seq');
            var data = {
                lockUserId: self.$cont.find('#lockUserId').val(),
                pageCode: self.$cont.find('#pageCode').val()
            };
            self.options = $.extend(true, {}, data);
            
            var register = {
                privcyCheck: {
                    required: true,
                    msgTarget: '.err-block',
                    errorMsg: '개인정보 수집 및 이용에 동의 하셔야 이용 가능합니다.'
                },
                sympCd: {
                    required: true,
                    msgTarget: '.topic-msg',
                    errorMsg: '정확한 제품증상을 선택해 주세요.'
                },
                sympSubCode: {
                    required: true,
                    msgTarget: '.sub-topic-msg',
                    errorMsg: '정확한 세부 증상을 선택해 주세요.'
                },
                sympCodeThree: {
                    required: true,
                    msgTarget: '.three-topic-msg',
                    errorMsg: '정확한 세부 증상을 선택해 주세요.'
                },
                date: {
                    required: true,
                    msgTarget: '.calendar-area .date .err-msg',
                    errorMsg: '날짜를 선택해 주세요.'
                },
                time: {
                    required: true,
                    msgTarget: '.calendar-area .time .err-msg',
                    errorMsg: '시간을 선택해 주세요.'
                },
                // topic : {
                //     required : true,
                //     msgTarget : '.topic-msg'
                // },
                // subTopic : {
                //     required : true,
                //     msgTarget : '.sub-topic-msg'
                // },
                userNm: {
                    required: true,
                    maxLength: 30,
                    pattern: /^[가-힣\s]+$|^[a-zA-Z\s]+$/,
                    msgTarget: '.err-block',
                    errorMsg: '이름을 입력해 주세요.',
                    patternMsg: '이름은 한글 또는 영문으로만 입력해 주세요.'
                },
                phoneNo: {
                    required: true,
                    minLength: 10,
                    maxLength: 11,
                    msgTarget: '.err-block',
                    errorMsg: '정확한 휴대폰 번호를 입력해 주세요.',
                    patternMsg: '정확한 휴대폰 번호를 입력해 주세요.',
                    validate : function(value){
                            return validatePhone(value);
                    } 
                }
            }
            
            if (seq) {
                // self.$cont.find('#seq').val(seq);
                $.extend(data, {seq: seq});
                self.seqFlag = true; //seqTab 노출 flag
                // self.centerList.hide();
            }else{
                self.seqFlag = false;
            }

            self.data = $.extend(true, {}, data);
            
            vcui.require(['ui/validation', 'helper/naverMapApi', 'support/common/searchModelNew.min'], function () {
                validation = new vcui.ui.CsValidation('.step-area', {register:register});
                naverMap = new vcui.helper.NaverMapApi({
                    mapService: 'naver',
                    keyID: 'ybmhlycwzo',
                    appKey: '2GlebZuTi7jGQGhglvFwbW40GacZ5JyGPTSNrS2E'
                }).load();   
                if (!isLogin) {
                    authManager = new AuthManager({
                            elem: {
                            popup: '#certificationPopup',
                            name: '#authName',
                            phone: '#authPhoneNo',
                            number: '#authNo'
                            },
                            register: {
                            authName: {
                                required: true,
                                maxLength: 30,
                                pattern: /^[가-힣\s]+$|^[a-zA-Z\s]+$/,
                                msgTarget: '.err-block',
                                errorMsg: '이름을 입력해 주세요.',
                                patternMsg: '이름은 한글 또는 영문으로만 입력해 주세요.'
                            },
                            authPhoneNo: {
                                required: true,
                                minLength: 10,
                                maxLength: 11,
                                msgTarget: '.err-block',
                                errorMsg: '정확한 휴대폰 번호를 입력해 주세요.',
                                patternMsg: '정확한 휴대폰 번호를 입력해 주세요.',
                                validate : function(value){
                                        return validatePhone(value);
                                } 
                            },
                            authNo:{
                                required: true,
                                msgTarget: '.err-block',
                                errorMsg: '인증번호를 입력해 주세요.',
                            }
                            }
                    });
                }
                    
                
                self.bindEvent();
                self.replaceTitleText();

                self.$userInfoBox.find('#addrForm').hide(); // 주소 검색 창 은폐
                self.$saleInfoBox.hide(); //구매정보
                self.$dateWrap.calendar({inputTarget:'#date'});
                self.$timeWrap.timeCalendarNew({inputTarget:'#time'});
                self.$cont.vcSearchModelNew({model:data}); 

            
            }); 
        },
        // BTOCSITE-47599 로그인 후, 정보 '선택해 주세요' or '입력해 주세요' 부분 문구 정비
        replaceTitleText: function(){
            if(!lgkorUI.isLogin) return;
    
            var isUserNm = $('#userNm').val() != '',
                isPhoneNo= $('#phoneNo').val() != '';
    
            if(isUserNm && isPhoneNo) {
                var title = $('.tit.re-text');
                var text = title.html();
                title.html(text.replace('입력해', '확인해'));
            }
        },
        //BTOCSITE-9289 : 페이지 나갈때 param보내는 기능 끄기
        clearPageLeventEvents : function() {
                $(window).off("beforeunload");
        },
        // BTOCSITE-62364 모델번호, 제조번호 입력
        // ##### 제조번호 규칙 #####
        // 제조번호 자리수는 10자리에서 18자리까지이다. 숫자3자리로 시작한다.
        // 1. 자리수가 14자리 이하일 때는, 숫자3자리 + 숫자알파벳 7~11자리 이다. 
        //    패턴 : /^[0-9]{3}[A-Za-z0-9]{7,11}$/
        // 2. 자리수가 15자리에서 18자리 이하일 때는, 숫자3자리+ 숫자알파벳 9~11자리 + 숫자 1~4자리
        //    패턴 : /^[0-9]{3}[A-Za-z0-9]{9,11}[0-9]{1,4}$/

        validateModelSelectBox: function() {
            // 모델명/제조번호 
            var self = this;
            var $msg = self.$modelSearchBox.find('.success-msg');
            var $errmsg = self.$modelSearchBox.find('.success-msg.error');
            var snVal = self.$modelSearchBox.find('input[name="sn"]').val();
			var searchVal = self.$modelSearchBox.find('#search').val();
			var $cateWrap = self.$modelSearchBox.find('.cate-wrap');
			var $prodBtn = self.$modelSearchBox.find('.btn-prod-next');

			var modelCode = $('#modelCode').val();
            var salesModelCode = $('#salesModelCode').val();
			var categoryNm = $('#categoryNm').val();
			var subCategoryNm = $('#subCategoryNm').val();
        
            var less = /^[0-9]{3}[A-Za-z0-9]{7,11}$/.test(snVal); //자리수가 14자리 이하일 때는, 숫자3자리 + 숫자알파벳 7~11자리
            var over = /^[0-9]{3}[A-Za-z0-9]{9,11}[0-9]{1,4}$/.test(snVal); //자리수가 15자리~18자리 이하일 때는, 숫자3자리+ 숫자알파벳 9~11자리 + 숫자 1~4자리
			var isValidSn = false;
			var isValidModel = false;
			var isValidCate = false;
            var isCate = categoryNm != '' && subCategoryNm != '';

            if(snVal == '') {
                return;
            };

            if(less || over){
                isValidSn = true;
                $msg.show();
                $errmsg.hide();
                
            }else{
                $msg.hide();
                $errmsg.show();
            }

			if(modelCode == searchVal && salesModelCode != '' &&  modelCode != '' && searchVal != '' && isCate){
				isValidModel = true;
			}
			
			if(modelCode != searchVal && salesModelCode == '' && modelCode == '' && searchVal != '' && isCate){
				isValidCate = true;
			}
			
			if(modelCode != searchVal && searchVal != '' && isValidSn){
				$cateWrap.show();
			}else{
				$cateWrap.hide();
			}
            
			if(searchVal != '' && snVal != '' && isValidSn && (isValidModel || isValidCate)){

				//버튼 활성화
                $prodBtn.prop('disabled', false);
			}else{
				$prodBtn.prop('disabled', true);
			}
        },
        delModelValue: function() {
            var self = this;
            $('#categoryNm').val("");
            $('#subCategoryNm').val("");
            $('#category').val("");
            $('#subCategory').val("");
            $('#modelCode').val("");
            $('#productCode').val("");
            $('#salesModelCode').val("");
            $('#serialNumber').val("");
            //모델명/제조번호
            self.$modelSearchBox.find('[class^="success-msg"]').hide();
			self.$modelSearchBox.find('.cate-wrap').hide();
            self.$modelSearchBox.find('[id="sn"]').val("");
            self.$modelSearchBox.find('[id="search"]').vcInputClearButton('updateVal', '');
            self.$modelSearchBox.find('[id="prodCategorySelect"]').prop('selectedIndex', 0).vcSelectbox('update');
            self.$modelSearchBox.find('[id="prodSubCategorySelect"]').children('option:not(:first-child)').remove();
            self.$modelSearchBox.find('[id="prodSubCategorySelect"]').prop('selectedIndex', 0).vcSelectbox('update');
            //제품군 
            self.$modelSelectBox.find('[id="categorySelect"]').prop('selectedIndex', 0).vcSelectbox('update');
            self.$modelSelectBox.find('[id="subCategorySelect"]').children('option:not(:first-child)').remove();
            self.$modelSelectBox.find('[id="subCategorySelect"]').prop('selectedIndex', 0).vcSelectbox('update');

        },
        bindEvent: function() {
            var self = this;

            $('[data-href="#ratesWarrantyGuidePopup"]').on('click', function() {
                lgkorUI.setAcecounter('www.lge.co.kr/acecount/visitInfoClick.do', '/acecount/visitInfoClickm.do');
            });
            
            $('#saleInfo .form-infos').show();

            // 모델 재선택 하기 후 이벤트
            self.$cont.on('reset', function(e) {
                self.reset();
            });

            // 모델 선택 후 이벤트
            self.$cont.on('complete', function(e, data) {    
                
                if(!isLogin) return; //BTOCSITE-62364 모델번호, 제조번호 입력
                
                //var url = self.resultUrl,
                var param = $.extend(true, self.data, data);
                
                // self.$cont.vcSearchModelNew('updateSummary', {
                //     product: [param.categoryNm, param.subCategoryNm, param.modelCode],
                //     reset: 'product'
                
                // });

                lgkorUI.showLoading();
                lgkorUI.requestAjaxDataPost(self.resultUrl, param, function(result) {
                    var resultData = result.data;
                    
                    self.$cont.vcSearchModelNew('updateSummary', {
                        product: [data.categoryNm, data.subCategoryNm, data.modelCode],
                        isMyProduct: $('#isMyProduct').val(),
                        reset: 'product'
                    });
                
                    self.setTopicList(resultData);
                    
                    if (!!resultData.warrantyText && resultData.warrantValue.toString()) {
                        $('#buyingdate').val(resultData.warrantValue);
                        //self.$salesDtWrap.children().eq(1).empty().html(resultData.warrantyText);
                        //self.$salesDtWrap.children().eq(0).hide();
                        //self.$salesDtWrap.children().eq(1).show();
                        $('#salesDt').find('.text').html(resultData.warrantyText);
                        $('#salesDt').find('.text').show();
                        //self.$salesDtWrap.children().eq(1).hide()
                        $('#salesDt').find('.rdo-list-wrap').hide();

                        // BTOCSITE-47599 로그인 후, 정보 '선택해 주세요' or '입력해 주세요' 부분 문구 정비
                        $('#saleInfo').find('.tit-wrap .tit').text('제품 구매 정보를 확인해 주세요');
                        
                    } else {
                        $('[name=buyingdate]').closest('.conts').find('.form-text').remove();
                        $('[name=buyingdate]').prop('checked', false);
                    
                        $('[name=buyingdate]').closest('.rdo-list-wrap').show();
                    }

                    
                    self.$stepArea.show(); // 정보 입력창 노출
                    
                    if($('#modelCode').val().length > 0){
                        self.$searchModelWrap.hide();
                    } 
                    
                    self.$stepCenter.removeClass('active');
                    //var target = $('.product-group');
                    //var itemCnt = target.find('ul li').length;
                    
                    self.$prodWrap.hide();
                    self.$myModelWrap.hide(); 
                    self.$selectedModelBar.show();
                    self.$stepArea.show();
                    self.$tabWrap.hide();
                    // $('#fastTimeArea').hide();	
                    
                    self.$productProblemsBox.addClass('open');
                    $('#agreeToTerms').find('.btn-group').show();
                    
                    lgkorUI.hideLoading();
                });

            });
                

            vcui.PubSub.on('completeSummary', function (e, data) {
                var param = data;
                self.param = $.extend(true, self.param, data);
                self.$selectedModelBar.show();
                self.$productProblemsBox.addClass('open');


                //BTOCSITE-91187 고객지원 > 서비스 예약 > 모델명, 제조번호 입력 시 OCR 제공
                setTimeout(function(){
                    self.validateModelSelectBox();
                }, 200);

            }); 

            self.$tabWrap.on('click', function() {
                var index = self.$tabWrap.vcTab("getSelectIdx");
                if(index.toString() == '0'){
                    self.delModelValue(); //BTOCSITE-62364 모델번호, 제조번호 입력
                }
            });

            //포커싱
            $('#saleInfo input[type=radio]').on('change', function(){
                lgkorUI.scrollTo($('#productProblems'));
                $('#productProblems').addClass('open');
            });

			//카테고리
			self.$modelSelectBox.find('#categorySelect').on('change', function(){
				self.$modelSelectBox.find('.btn-prod-next').prop('disabled', true); // 버튼 비활성화

                var superCate = $(this).find('option:selected').data('category-name');

                if(superCate == "all") {
                    self.$modelSelectBox.find('#subCategorySelect').find('option:not(:first-child)').remove();
                    self.$modelSelectBox.find('#subCategorySelect').vcSelectbox('update');
                }
				
			});
            self.$modelSelectBox.find('#subCategorySelect').on('change', function() {   //재품 카테고리 선택
                $('#salesDt').find('.rdo-list-wrap').show();
                $('#salesDt').find('.text').hide();
                // $('#productProblems').addClass('open');
                $('#agreeToTerms').find('.btn-group').show();
                
                //BTOCSITE-62364 모델번호, 제조번호 입력
                var superCate = $(this).find('option:selected').val();
                if(superCate !== "all") {                   
                    self.$modelSelectBox.find('.btn-prod-next').prop('disabled', false);
                }
            });

			//modelSearchBox 카테고리
			self.$modelSearchBox.find('#prodCategorySelect').on('change', function(){
                self.$modelSearchBox.find('.btn-prod-next').prop('disabled', true); // 버튼 비활성화

                var val = $(this).find('option:selected').data('category-name');
                if(val !== "all") {
                    $("#subCategory").val("");
                    $("#subCategoryNm").val("");
                }
			});
			//modelSearchBox 서브 카테고리
			self.$modelSearchBox.find('#prodSubCategorySelect').on('change', function(){
				var $this = $(this);
				var val = $this.find('option:selected').val();
                var nm = $this.find('option:selected').text();
                $("#subCategory").val(val);
                $("#subCategoryNm").val(nm);
				
				if(val !== "all") {
					self.validateModelSelectBox();
				}
			});

            //BTOCSITE-62364 모델번호, 제조번호 입력
            $('.prod-model-box').on('click', '.btn-prod-open', function() {
                var $this = $(this);
                var idx = $this.parents('.prod-model-box').index();

                if($this.parents('.prod-model-box').hasClass('open')) return;

                $('.prod-model-box').removeClass('open');
                $('.prod-model-box').eq(idx).addClass('open');
                
                switch (idx){
                    case 0: //모델명/제조번호 선택
                        $('#categoryNm').val("");
                        $('#subCategoryNm').val("");
                        $('#category').val("");
                        $('#subCategory').val("");
                        self.$modelSelectBox.find('[id="categorySelect"]').prop('selectedIndex', 0).vcSelectbox('update');
						self.$modelSelectBox.find('[id="subCategorySelect"]').children('option:not(:first-child)').remove();
						self.$modelSelectBox.find('[id="subCategorySelect"]').prop('selectedIndex', 0).vcSelectbox('update');
                        break;
                    case 1: //제품군 선택
                        $('#categoryNm').val("");
                        $('#subCategoryNm').val("");
                        $('#category').val("");
                        $('#subCategory').val("");
                        $('#modelCode').val("");
                        $('#productCode').val("");
                        $('#salesModelCode').val("");
                        $('#serialNumber').val("");
                        self.$modelSearchBox.find('input[type="text"]').val("");
                        self.$modelSearchBox.find('.success-msg').hide();
                        //BTOCSITE-80487 고객지원 > 출장예약 > 모델명 입력 > 자동완성 미선택
                        self.$modelSearchBox.find('[id="prodCategorySelect"]').prop('selectedIndex', 0).vcSelectbox('update');
                        self.$modelSearchBox.find('[id="prodSubCategorySelect"]').children('option:not(:first-child)').remove();
                        self.$modelSearchBox.find('[id="prodSubCategorySelect"]').prop('selectedIndex', 0).vcSelectbox('update');
                        break;
                }
                    
                $('.prod-model-box').eq(idx).find('.btn-prod-next').prop('disabled', true);
            });

            //BTOCSITE-62364 모델번호, 제조번호 입력
            $('.prod-model-box').on('click', '.btn-prod-next', function() {
                var $this = $(this);
                var idx = $this.parents('.prod-model-box').index();

                switch (idx){
                    case 0: //모델명/제조번호 입력
                        $('.success-msg').hide();
                        var snVal = self.$modelSearchBox.find('input[name="sn"]').val();
                        $('#serialNumber').val(snVal);

						var modelCode = self.$modelSearchBox.find('input[id="search"]').val().toUpperCase();
						$('#modelCode').val(modelCode);
					
						var param = {
							modelCode: modelCode,
						}
						$.extend(self.param, param);

						self.$cont.vcSearchModelNew('updateSummary', {
						    product: [self.param.categoryNm, self.param.subCategoryNm, self.param.modelCode],
						    reset: 'product'
						});

                        break;
                    case 1: //제품군 선택
                        break;
                }
                // self.$selectedModelBar.show();
                self.$stepArea.show();
                self.$prodWrap.hide();
                //self.$searchArea.hide();
                self.$tabWrap.hide();
            });

            // BTOCSITE-62364 모델번호, 제조번호 입력
            self.$modelSearchBox.on('keyup', 'input[name="sn"]', function(e) {
                self.validateModelSelectBox();
        
            });

            self.$modelSearchBox.on('focusout', 'input[id="search"]', function(e) {
				e.preventDefault();
                var searchVal = $(this).val().toUpperCase();
                var chkdata = self.$modelSearchBox.find('.keyword-list').find('li').find('[data-model-code="'+searchVal+'"]');
                
                if(chkdata.length > 0){
                    chkdata.trigger('click');

					self.$modelSearchBox.find('[id="prodCategorySelect"]').prop('selectedIndex', 0).vcSelectbox('update');
					self.$modelSearchBox.find('[id="prodSubCategorySelect"]').children('option:not(:first-child)').remove();
					self.$modelSearchBox.find('[id="prodSubCategorySelect"]').prop('selectedIndex', 0).vcSelectbox('update');
                }
            });
            self.$modelSearchBox.on('keyup', 'input[id="search"]', function(e) {
                e.preventDefault();

                var searchVal = $(this).val().toUpperCase();
                var chkdata = self.$modelSearchBox.find('.keyword-list').find('li').find('[data-model-code="'+searchVal+'"]');
                $(this).val(searchVal);

				var salesModelCode = $('#salesModelCode').val();
				if((e.keyCode === vcui.keyCode.BACKSPACE && salesModelCode != '') || (chkdata.length == 0 && salesModelCode != '')) {
					//모델명 조회 후 백스페이스 삭제
					$('#modelCode').val("");
					$('#productCode').val("");
					$('#salesModelCode').val("");
					$('#category').val("");
					$('#categoryNm').val("");
					$('#subCategory').val("");
					$('#subCategoryNm').val("");
				}

				if (e.keyCode == 13) {  
					if(chkdata.length > 0){
						chkdata.trigger('click');
					}
				}

				self.validateModelSelectBox();
            });

            self.$modelSearchBox.on('click', '.btn-search', function(e) {
                e.preventDefault();
                var searchVal = $('#search').val().toUpperCase();
                var chkdata = self.$modelSearchBox.find('.keyword-list').find('li').find('[data-model-code="'+searchVal+'"]');

				if(chkdata.length > 0){
					chkdata.trigger('click');                    
				}
            });

            self.$modelSearchBox.on('click', '.btn-delete', function(e) {
                self.$modelSearchBox.find('input[type="text"]').val('');

                self.delModelValue();
                self.validateModelSelectBox();
        
            });

            self.$modelSearchBox.on('click', '.search-layer .autocomplete-box a', function(e) {  //오토컴플릿 목록 선택시 
                $('#salesDt').find('.rdo-list-wrap').show();
                $('#salesDt').find('.text').hide();
                // $('#productProblems').addClass('open');
                $('#agreeToTerms').find('.btn-group').show();

                // BTOCSITE-62364 모델번호, 제조번호 입력
                $('.keyword-search').removeClass('on');
                setTimeout(function(){
                    self.validateModelSelectBox();
                }, 100);
            });
                // 증상 선택
            self.$topicList.on('change', '[name=sympCd]', function() {
                //BTOCSITE-79146 고객지원 > 센터방문예약> 프로세스 개선
                self.centerList.find('li').removeClass('on');
                self.$stepDate.removeClass('active');
                self.comlpit.hide(); //예약 버튼 비활성화

                $('#agreeToTerms').find('.btn-group').show();
                self.$stepCenter.removeClass('active');
                // 상위증상 선택하면 세부증상 리셋
                $('#sympSubCode').val('');
                $('#sympSubCodeNm').val('');
                $('#sympCodeThree').val('');
                $('#sympCodeThreeNm').val('');

                self.$sub1TopicBox.hide();
                self.$sub1TopicSelect.empty();
                self.$sub1TopicBox.find('.ui-selectbox-list ul').empty();
                
                self.$sub2TopicBox.hide();
                self.$sub2TopicSelect.empty();
                self.$sub2TopicBox.find('.ui-selectbox-list ul').empty();
                
                self.$solutionsBanner.hide();
                var currentTopic = this; //BTOCSITE_6554
                
                // 20210610 세척서비스 증상 선택시 팝업 띄움
                var topicName = $(this).data('topicName');
                var subCtg = $('#subCategory').val(); // BTOCSITE-21883 고객지원: 베스트케어 지원  
                
                
                var value = $('#topicList').find('.rdo-list').find('input[type=radio]:checked').attr('value');
                var name = $('#topicList').find('.rdo-list').find('input[type=radio]:checked').attr('data-topic-name');
                $('#sympCd').val(value);
                $('#sympCdNm').val(name);
                
                // BTOCSITE-6144 세척서비스 중지 팝업 다시 원래대로 원복
                // BTOCSITE-13336 고장증상 '세척서비스' 예약 가능하게 기능 수정 요청
                var alertMsg = '가전 <strong class="point">세척 서비스</strong>는 <strong>콜센터 [1544-7777]로</strong><br>전화 주시거나, <strong>전화 상담 예약</strong>을 하시면<br>전문 상담사 상담 후 접수를 도와 드리겠습니다.<br><br>전화 상담 예약을 안내해 드릴까요?';                
                if( topicName === "세척서비스" && (subCtg == 'CT50019244' || subCtg == 'CT50019259')){
                lgkorUI.confirm(alertMsg,{
                    typeClass:'type2',
                    title:'',
                    okBtnName: '네',
                    cancelBtnName: '아니요',
                    ok: function() {
                        location.href = "/support/request-call-reservation";
                    },
                    cancel: function() {
                        $(currentTopic).prop('checked', false); //BTOCSITE_6554
                    }
                });
                }

                // BTOCSITE-21883 고객지원: 베스트케어 지원   
                var alertMsg2 = '해당 서비스는 LG 베스트 케어 > 가전세척에서 예약하실 수 있습니다. <br><br>가전세척 예약을 안내해 드릴까요?';          
                if( topicName === "세척서비스" && (subCtg != 'CT50019244' && subCtg != 'CT50019259')){
                    lgkorUI.confirm('',{
                        typeClass:'type2',
                        title:alertMsg2,
                        okBtnName: '네',
                        cancelBtnName: '아니요',
                        ok: function() {
                            location.href = "/lg-best-care/home-appliance-cleaning/reservation";
                        },
                        cancel: function() {
                            $(currentTopic).prop('checked', false);
                            self.$sub1TopicBox.hide();
                            return;
                        }
                    });
                } else {
                    var url = self.$topicListWrap.data('ajax'),
                    param = {
                        topic: $(this).val(),
                        serviceType: $('#serviceType').val(),
                        productCode: $('#productCode').val()
                    };
                    
                    /* BTOCSITE-3411 add :: 세척 서비스 팝업 얼렛으로 변경 */
                    // var alertMsg = '<p>일시적으로 가전 <strong class="point">세척 서비스</strong> 제공을 중지합니다.<br>서비스 안정화 이후 다시 진행될 예정이오니 양해 바랍니다.</p>';
                    // if( topicName === "세척서비스" ){
                    //     $(this).prop('checked', false);
                    //     lgkorUI.alert(alertMsg);
                    // }
                    /* BTOCSITE-3411 add :: 세척 서비스 팝업 얼렛으로 변경 */
                    self.$solutionsBanner.hide();
                    self.requestSub1Topic(url, param);
                    self.$sub2TopicSelect.hide();

                    if (self.autoFlag) {
                        self.$stepInput.find('.step-btn-wrap').show();
                        self.$stepDate.removeClass('active');
                        // self.$stepEngineer.removeClass('active');
                        self.$dateWrap.calendar('reset');
                        self.$timeWrap.timeCalendarNew('reset').hide();  
                        self.autoFlag = false;
                    }
                }
            });

                // 세부1 증상 선택
            self.$sub1TopicSelect.on('change', function() {
                var $this = $(this);
                var value = $('#stopic01').find("option:selected").val();
                var name = $('#stopic01').find("option:selected").html();
                $('#sympSubCode').val(value);
                $('#sympSubCodeNm').val(name);
                $('#sympCodeThree').val('');
                $('#sympCodeThreeNm').val('');
                
                self.$stepInput.find('.step-btn-wrap').show();
                self.$stepDate.removeClass('active');
                self.$dateWrap.calendar('reset');
                self.$timeWrap.timeCalendarNew('reset').hide();  
                self.$stepCenter.removeClass('active');
                self.comlpit.hide();

                validation.validate(['sympSubCode']); //BTOCSITE-69400 고객지원 > 출장예약 > 구매정보 입력 단계 수정 및 스타일러 도어 대응

                var url = self.$sub1TopicSelect.data('ajax'),
                param = {
                    topic: $('input[name=sympCd]:checked').val(),
                    subTopic: $this.val(),
                    productCode: $('#productCode').val(),
                    serviceType: $('#serviceType').val()
                };
                self.$solutionsBanner.hide();
                //self.$sub2TopicBox.hide();
                self.$sub2TopicSelect.empty();
                self.$sub2TopicBox.find('.ui-selectbox-list ul').empty();
                    
                self.requestSub2Topic(url, param);
            });

            // 세부2 증상 선택
            self.$sub2TopicSelect.on('change', function() {
                var $this = $(this);
                if (isLogin) {
                    //$('#stepMap').show().addClass('active');
                    //lgkorUI.scrollTo($(self.$stepCenter));
                    $('#privcyCheck').prop("checked", true); //약관동의
                }	
                lgkorUI.scrollTo($('#addDesc'));
                $('#userInfo').addClass('open');
                
                if($this.find("option:selected").text() === "세부 증상을 선택해 주세요") {
                    return;
                }
                var value = $('#stopic02').find("option:selected").val();
                var name = $('#stopic02').find("option:selected").html();
                $('#sympCodeThree').val(value); 
                $('#sympCodeThreeNm').val(name);

                validation.validate(['sympCodeThree']); //BTOCSITE-69400 고객지원 > 출장예약 > 구매정보 입력 단계 수정 및 스타일러 도어 대응
                
                //BTOCSITE-90818 고객지원 > 서비스 센터 > 스스로해결 콘텐츠 노출
                var url = self.$sub2TopicSelect.data('ajax'),
                    param = {
                        topic: self.$stepArea.find("#sympCd").val(),
                        subTopic: self.$stepArea.find("#sympSubCode").val(),
                        sympCodeThree: value,
                        productCode: self.$stepArea.find("#productCode").val(),
                        serviceType: self.$stepArea.find('#serviceType').val(),
                    };

                self.requestSolutions(url, param);

                //BTOCSITE-79146 고객지원 > 센터방문예약> 프로세스 개선
                self.$stepInput.find('.btn-center').trigger('click');

                if(!self.seqFlag){
                    self._setUserAdressSearch(); // 내주소 호출
                    self.$seqTab.find('li').removeClass('on').eq(0).addClass('on');
                    self.$dirTab.hide();
                }

            });
            //BTOCSITE-84932 (WAF 이슈 대응) 고객문의글에 개인정보 Pattern 인식 시, Alert 적용
            self.$textarea.on('focusout', function(){
                var numbers = $(this).val().replace(/[^0-9]/g, "");
                if(numbers.length >= 11){
                    lgkorUI.confirm('', {
                        typeClass: 'type2',
                        title: '<p>혹시 전달사항에 개인 정보(전화번호, 주소 등)가 포함되어 있나요?<br>한 번 더 체크해 주세요.</p>',
                        okBtnName: '개인 정보 없음',
                        cancelBtnName: '수정하기',
                        ok:function(){
                            setTimeout(function(){
                                lgkorUI.scrollTo(self.$userInfoBox);
                                self.$userInfoBox.focus();
                            }, 100);
                        },
                        cancel:function(){ 
                            setTimeout(function(){
                                numbers = '';
                                self.$textarea.focus();
                            }, 500);
                        },
                    });
                }

            });


            // 엔지니어 선택 팝업 오픈
            self.$engineerOpener.on('click', function() {
                var $this = $(this);
                var url = self.$engineerPopup.data('engineerListUrl');
                var data = $.extend(true, {}, self.data),
                    param = {
                        category: data.category,
                        subCategory: data.subCategory,
                        productCode: data.productCode,
                        serviceType: data.serviceType,
                        deptCode: self.data.deptCode,
                        lockUserId: data.lockUserId,
                        date: data.date,
                        time: data.time      
                    };
                
                
                lgkorUI.showLoading();
                lgkorUI.requestAjaxDataPost(url, param, function(result) {
                    var data = result.data,
                        arr = data.engineerList instanceof Array ? data.engineerList : []; 
            
                    if (data.resultFlag == 'Y') {  
                        if (arr.length) {
                            var html = vcui.template(engineerTmpl, data);
                            
                            /* BTOCSITE-7660 고객지원 - 출장/내방/예약변경 시 SE 사진 비노출 요청 */
                            // self.$engineerSlider.find('.slide-track').html(html); // 원본
                            self.$engineerSlider.find('.engineer-infoP').html(html);
                            /* //BTOCSITE-7660 고객지원 - 출장/내방/예약변경 시 SE 사진 비노출 요청 */
            
                            self.$engineerSlider.vcCarousel('reinit');
                        } else {
                            lgkorUI.alert('', {
                                title: '방문 가능한 다른 서비스매니저가 없습니다.'
                            }, $this[0]);
                        }
                    } else {
                        if (data.resultMessage) {
                            lgkorUI.alert("", {
                                title: data.resultMessage
                            }, $this[0]);
                        }
                    }
                    lgkorUI.hideLoading();
                });
            });

            self.$engineerSlider.on('carouselreinit', function() {
                self.$engineerPopup.vcModal();
            });
            
            self.$engineerPopup.on('modalhidden', function() {
                self.$engineerOpener.focus();
            });
            // 센터 찾기 선택
            self.$stepInput.on('click', '.btn-center', function() {
                var shopId = $(this).data('shopId'),
                    deptCode = $(this).data('deptCode'),
                    result;
                
                self.$cont.find('#seq').val(shopId);
            
                self.data = $.extend(self.data, {
                    seq: shopId,
                    deptCode: deptCode
                });
            
                self.latitude = '';
                self.longitude = '';
               
                
                result = validation.validate(['sympCd', 'sympSubCode', 'sympCodeThree', 'userNm', 'phoneNo', 'privcyCheck']);
                if(result.success) {
                    
                    //self.$stepCenter.show().addClass('active');
                    // 센터 조회 
                    var url = self.centerUrl;
                    var seq = lgkorUI.searchParamsToObject('seq');
                    var dataparam = {
                        lockUserId: self.$cont.find('#lockUserId').val(),
                        pageCode: self.$cont.find('#pageCode').val()
                    };


                    
                    if(seq){
                        // self.$cont.find('#seq').val(seq);
                        $.extend(dataparam, {seq: seq});
                        param = $.extend(true, self.data, dataparam)
                        self.requestCenterData(param, url);
                    // 내주소 호출로 삭제
                    // }else{
                    //     self.requestCenterData();
                    }

                    //BTOCSITE-79146 고객지원 > 센터방문예약> 프로세스 개선
                    self.$stepCenter.addClass('active');
                    self.$completeBtns.hide();
                    self.$stepDate.removeClass('active');
             
                }else{
                    lgkorUI.scrollTo(self.$productProblemsBox);//증상으로 이동
                }
            
            });
            
            // $('.contents.visit-center').find('.my-product-wrap li').each(function(){
            //     $(this).find('a').on('click',function(){
            //         self.$stepInput.show();
            //     });
            // });

            // 증상 선택
            // 세부 증상 선택
            // 솔루션 배너
            self.$solutionsBanner.find('.btn-link').on('click', function(){
                /* var parents = $(this).closest('.accord-wrap');
                    var topicName = $(this).closest('.accord-wrap').find('.topics .rdo-list li:first-child input').attr('name');
                
                    var param = {
                    topic : parents.find('.topics input[name='+topicName+']:checked').val(),
                    subToic : parents.find('#stopic02 select option:selected').val(),
                    productCode : $('#productCode').val(),
                    page: 1
                    };
                    lgkorUI.setAcecounter('www.lge.co.kr/acecount/visitSolutionsClick.do', '/acecount/visitSolutionsClickm.do');
                    self.setSolutions(param, false); */
                self.$solutionsBanner.hide();
                lgkorUI.scrollTo($('#userInfo'));
            });
            
            self.$solutionsBanner.find('.btn-chatbot').on('click', function(){
                var subTopic =  $('#sTopic02Select option:selected').text();
                var speech = $('#subCategoryNm').val() + ' ' + subTopic;
                var chatUrl = lgkorUI.getChatDomain() + "/kr/index.html?service=cs&speech=" + encodeURIComponent(speech);
                //var chatUrl = "https://chat-qa.lgechat.co.kr/?service=cs&speech=" + encodeURIComponent(speech);
                lgkorUI.getChatPinCodeAsUrl(chatUrl, 450, 760);
            });

            //BTOCSITE-90818 고객지원 > 서비스 센터 > 스스로해결 콘텐츠 노출
            self.$solutionsBanner.on('click', '.qna-list button', function(e){
                var itemId = $(this).data("itemId");
                var itemTitle =  $(this).html();

                self.$solutionsPopup.find('.qna-cont').hide();
                self.$solutionsPopup.find('.qna-cont[data-item-id=' + itemId + ']').show();
                self.$solutionsPopup.find('.pop-header .tit span').empty().html(itemTitle);
                self.$solutionsPopup.vcModal({opener:$(this)});
            });
            
            // 날짜 선택
            self.$dateWrap.on('dateselected', function(e, date) {
                //self.data['date'] = date;
                $('#date').val(date);
                self.comlpit.hide();
                self.requestTime();
            });
            self.$timeWrap.on('timeselected', function(e, time) {
                //self.data['time'] = time;
                $('#time').val(time);

                //BTOCSITE-9289 : 시간까지 선택된 상태에서 페이지 나갈때 param보내는 기능 추가
                //var unlockUrl = self.$stepDate.data('unlockUrl'); //데이터 가져오기
                var unlockUrl = $('#canclePopup').data('unlockUrl'); //데이터 가져오기
                var unlockParam = {}; //unlockParam 빈 객체를 만들기
            
                if( $('#productCode').val() != undefined) { //빈값이진 undefined인지 확인 : undefined 가 아니면 unlockParam.productCode 는 밸류값이 들어간다
                    unlockParam.productCode = $('#productCode').val()
                }
                if( $('#serviceType').val() != undefined) {
                    unlockParam.serviceType = $('#serviceType').val()
                }
                if( $('#lockUserId').val() != undefined) {
                    unlockParam.lockUserId = $('#lockUserId').val()
                }
            
                lgkorUI.requestAjaxDataPost(unlockUrl, unlockParam, function(res){
                    if (res.data.resultFlag == 'Y') {
                        //console.log('최초 unlockParam', unlockParam);
                    }
                })
            
                // ////console.log('페이지 나갈때 unlockParam', unlockParam);
                $(window).on("beforeunload", function() {
                    lgkorUI.requestAjaxDataPost(unlockUrl, unlockParam, function(res){
                        if (res.data.resultFlag == 'Y') {
                            //console.log('페이지 나갈때 unlockParam', unlockParam);
                        }
                    })
                });
            
                self.reqestEngineer();
                //$('#stepEngineer').addClass('active');
                //$('#stepEngineer .btn-group').show();
                // self.comlpit.show(); // reqestEngineer 예약완료후 버튼 활성화
            });
            
            self.warrantyGuide.on('modalshown', function(){
                var $this = $(this);
                var $tab = $this.find('.ui_tab');
                var $tabCont =  $this.find('.tabs-contents');
            
                $tabCont.hide().eq(0).show();
            });

                // self.warrantyGuide.find('.ui_tab').on('tabchange', function(e, data){
                //     var $this = $(this);
                //     var $popupCont = $this.closest('.pop-conts');
                //     var $tabCont = $popupCont.find('.tabs-contents');

                //     //console.log(data.button[0].hash)

                //     $tabCont.hide();
                //     $tabCont.filter(data.button[0].hash).show();
                // })


            // 엔지니어 선택
            self.$engineerPopup.find('.btn-group .btn').on('click', function() {
                var url = self.$engineerPopup.data('lockUrl'),
                    $this = self.$engineerPopup.find('[name=engineer]').filter(':checked'),
                    infoData = $this.data(),
                    param, data;
            
                self.data = $.extend(self.data, infoData);
                data = self.data;
                param = {
                    productCode: data.productCode,
                    serviceType: data.serviceType,
                    lockUserId: data.lockUserId,
                    date: data.date,
                    time: data.time,
                    beforeEngineerCode: $('#engineerCode').val()
                }
            
                lgkorUI.showLoading();
                lgkorUI.requestAjaxDataPost(url, data, function(result) {
                    lgkorUI.hideLoading();
                    
                    var data = result.data;
            
                    if (data.resultFlag == 'Y') {
                        self.updateEngineer(infoData);
                    } else {
                        if (data.resultMessage) {
                            lgkorUI.alert("", {
                                title: data.resultMessage
                            });
                        }
                    }
                });
            });

            self.$authPopup.find('.btn-send').on('click', function() {
                authManager.send(this);
            });

            self.$authPopup.find('.btn-auth').on('click', function() {
                authManager.confirm(this, function(success, result) {
                    success && self.requestComplete();
                });
            });

            // 요금 및 보증 기간 안내
            self.warrantyGuide.on('modalhide', function(){
                var $this = $(this);
                var $tab = $this.find('.ui_tab');
                
                // BTOCSITE-13599 요금 및 보증기간 안내 팝업 수정
                $tab.vcTab("select", 0);
            });
                
                //BTOCSITE-9289 : 예약 중일때 취소시 param 보내는 여부
            $('#canclePopup .btn-cancel-confirm').on('click', function(e){
                //e.preventDefault();
                self.clearPageLeventEvents();
                
                var unlockUrl = $('#canclePopup').data('unlockUrl'); //데이터 가져오기
                var _href = $(this).attr('href');
                var unlockParam = {}; //unlockParam 빈 객체를 만들기
                
                if( $('#productCode').val() != undefined) { //빈값이진 undefined인지 확인 : undefined 가 아니면 unlockParam.productCode 는 밸류값이 들어간다
                    unlockParam.productCode = $('#productCode').val()
                }
                if( $('#serviceType').val() != undefined) {
                    unlockParam.serviceType = $('#serviceType').val()
                }
                if( $('#lockUserId').val() != undefined) {
                    unlockParam.lockUserId = $('#lockUserId').val()
                }
                
                //보내는 param 확인
                // //console.log('unlockParam', unlockParam)
                
                //데이터 통신
                lgkorUI.requestAjaxDataPost(unlockUrl, unlockParam, function(res){
                    if (res.data.resultFlag == 'Y') {
                            location.href = _href; 
                    } else {
                            location.href = _href; 
                    }
                })
            });

            // BTOCSITE-13601 모델명 확인 방법 > 이미지 확대 추가
            var $imgView = $('.btn-img-view');
            $('#select2').on('change', function(){
                // 이미지가 없는 경우 no-img 삭제
                if(!(lgkorUI.NO_IMAGE_MODEL_NAME != $imgView.find('img').attr('src'))) {
                    $imgView.find('img').removeClass('no-img');
                }
            });

            // BTOCSITE-13601 모델명 확인 방법 > 이미지 확대 추가
            $imgView.on('click', function(e) {
                e.preventDefault();
                
                if($(this).find('img').hasClass('no-img')) return;

                var domain=location.origin;
                var agent = navigator.userAgent;
                var imgUrl=domain + $(this).attr('href');
                var imgAlt = $(this).find('img').attr('alt');
                if(!vcui.detect.isMobileDevice){
                    window.open(imgUrl, '', '');
                    return
                }

                var currOption = $('#select2 option:selected');
                var popTitle = currOption.hasClass('placeholder') ? '모델명 확인 방법' : currOption.text();
                var $zoomPopup = $('#imgZoomPopup');
                var $zoomImg = $('#imgZoomPopup img');
                $zoomImg.attr('src', imgUrl);
                $zoomImg.attr('alt', imgAlt);

                $zoomPopup.find('.tit').html('<span>'+popTitle+'</span>');
                $zoomPopup.vcModal('open');
            });
            self.localGu.on('change', function(){  //지역에서 구 선택 이밴트
                self.searchType = 'local';
                self._setLocalSearch();
            });
            self.localSi.on('change', function(e){  //지역에서 시 선택
                if(e.target.value == '세종'){
                    self.localGu.prop('selectedIndex', 0).prop('disabled', true).vcSelectbox('update');
                    self.searchType = 'local';
                    self._setLocalSearch();
                    return;
                }

                self._loadLocalAreaList(e.target.value);
            });

            //예약 가능 센터만 보기
            $('#centerList').find('[name=centerSort]').on('change', function(e){
                var $centerList =  $('#centerList'),
                    $list = $centerList .find('.center-result-list'),
                    $noData = $centerList .find('.no-data'),
                    val = $centerList.find('input[name=centerSort]:checked').val(),
                    totalLength = $list.find('li').length,
                    disLength = $list.find('button:disabled').length;
                
                if(totalLength <= 0) return;

                if(val != 'on'){
                    $list.find('li').show();
                    $noData.hide();
                }else{
                    $list.find('li button:disabled').parents('li').hide();
                    if(totalLength === disLength) {
                        $noData.show().html('예약 가능한 센터가 없습니다.');
                    }
                }
            });
            
            self.centerList.on('click', '.center-info', function(e, data){  //센타리스트 클릭시 이밴트
                e.preventDefault();
                //console.log("self.centerList.on('click', function(){");
                var $this = $(this);
                if($this.attr("disabled") == "disabled"){    //가장빠른예약일시 없을경우 리턴
                	return;
                }
                self.centerList.find('li').removeClass('on');
                $this.closest('li').addClass('on');
                $('#deptCode').val($this.closest('li').attr('deptcode'));
                self.requestDate("reservation");
                $this.addClass('on').siblings().removeClass('on');
                ////console.log($this.find('.center-info-name').html());
                //self.centerList.find('#centerName').html($this.find('.center-info-name').html());  //일정확정 관련 지점명 출력
                //lgkorUI.scrollTo($(self.fastItmeconfom));
            });
            self.centerList.on('click', '.btn.border', function(e){    //방문예약
                e.preventDefault();
                var $this = $(this);

                self.comlpit.hide(); //예약 버튼 비활성화
                self.centerList.find('li').removeClass('on');
                $this.closest('li').addClass('on');
                var deptCode = $this.closest('li').attr('deptcode');
                $('#deptCode').val(deptCode);
                var shopId = $this.data('shopId'),
                shopName = $this.data('shopName');
                
                $('#centerCode').val(deptCode);
                $('#centerNm').val(shopName);

                //BTOCSITE-79146 고객지원 > 센터방문예약> 프로세스 개선
                var result = validation.validate(['sympCd', 'sympSubCode', 'sympCodeThree']);
                if(result.success) {
                    self.requestDate("reservation");
                }else{
                    $this.parents('li').removeClass('on');
                    lgkorUI.scrollTo(self.$productProblemsBox); //증상으로 이동
                }
            });
            self.centerList.on('click', '.btn-link', function(e){  //센타정보
                e.preventDefault();
                var id = $(this).attr("href").replace("#", "");
                var windowHeight = $(window).innerHeight();
                window.open(self.detailUrl+"-"+id+"?directYn=Y", "_blank", "width=1070, height=" + windowHeight + ", location=no, menubar=no, status=no, toolbar=no, scrollbars=1");
            });
            
            
            self.searchkeyword.on('keyup', function(e) { //검색에서 엔터키입력
                    self.searchType = 'center';
                if (e.keyCode == 13) {
                    e.preventDefault();
                    self._setSearch();
                }
                
            });
            
            self.searcharea.on('click','#subwaysearchbtn', function(e){  
                e.preventDefault();
                ////console.log("self.searchbtn.on");
                self.searchType = 'center';
                self._setSearch();
            });
            
            //취소 , 완료
            self.comlpit.on('click', '.gray', function(){
                //console.log("취소");
            }).on('click', '.btn-confirm', function(){
                //console.log("완료");
                var result = validation.validate();
                if (result.success == true) { 
                    var isMobileProduct = ($('#category').val() == "CT50019096");
                    
                    if (isLogin || isMobileProduct) {
                        lgkorUI.confirm('', {
                            title:'예약 하시겠습니까?',
                            okBtnName: '확인',
                            cancelBtnName: '취소',
                            ok: function() {
                                self.clearPageLeventEvents() //BTOCSITE-9289 : 페이지 나갈때 param보내는 기능 끄기
                                self.requestComplete();
                            }
                        });       
                    } else {
                        authManager.open(function() {
                            self.$authPopup.find('#authName').val($('#userNm').val()).prop('readonly', true);
                            self.$authPopup.find('#authPhoneNo').val($('#phoneNo').val()).prop('readonly', true);  
                        });
                    }
                }else{
                    lgkorUI.scrollTo(self.$productProblemsBox); //증상으로 이동
                }
            });
            // 지하철역 검색
            self.$subwayCitySelect.on('change', function(e){
                //console.log("self.$subwayCitySelect.on('change', ");
                lgkorUI.requestAjaxData(self.subwayUrl, {codeType:'SUBWAY', pcode:e.target.value}, function(result){
                    self._setSubwayOption(result.data, self.$subwayLineSelect, {codeName:"호선 선택", code:""}, "code");
                    
                });
                
                self.$subwayLineSelect.prop('disabled', false);
                //setTimeout(function(){
                //$('#subwayLineBox').trigger('click');
                    //self.$subwayLineSelect.prop('disabled', false);
                    //$('#subwayLineBox').find('.ui-selectbox-wrap').removeClass('disabled');
                //}, 1000);
                setTimeout(function(){
                    $('#subwayLineBox').find('.ui-selectbox-wrap').addClass('active'); // 서브 카테고리 자동 열림
                    
                //setTimeout(function(){
                    $('#subwayLineBox').find('.ui-selectbox-wrap').addClass('on'); // 서브 카테고리 자동 열림
                    
                //}, 2000);
                //setTimeout(function(){
                    $('#subwayLineBox').find('.ui-selectbox-list').show();
                //}, 2500);
                }, 800);
                
            });
            self.$subwayLineSelect.on('change', function(e){
                lgkorUI.requestAjaxData(self.stationUrl, {codeType:'SUBWAY', pcode:e.target.value}, function(result){
                    self._setSubwayOption(result.data, self.$subwayStationSelect, {codeName:"역 선택", code:""}, "codeName");
                    
                });
                self.$subwayStationSelect.prop('disabled', false);
                setTimeout(function(){
                    $('#subwayStationBox').find('.ui-selectbox-wrap').addClass('active'); // 서브 카테고리 자동 열림
                    $('#subwayStationBox').find('.ui-selectbox-wrap').addClass('on'); // 서브 카테고리 자동 열림
                    $('#subwayStationBox').find('.ui-selectbox-list').show();
                }, 800);
            });
            
            self.$subwayStationSelect.on('change', function(e){
                self.$searchSubwayButton.prop('disabled', false);
                self.searchType = 'subway'; 
                self._setSubwaySearch();
            });
            /*
            self.$searchSubwayButton.on('click', function(e){
                self.searchType = 'subway'; 
                self._setSubwaySearch();
            });
            */
            //희망일시 가장빠른 예약일시 선택 관련 버튼 이밴트
            /*
            self.fastItmeconfombtn.on('click', '.btn-cal', function(){
                //console.log("self.fastItmeconfombtn.btn-cal");
                $('#changDT').show().addClass('active');
                self.fastItmeconfom.hide().removeClass('active');
                lgkorUI.scrollTo($('#changDT'));
            }).on('click', '.btn-comp', function(){
                //console.log("self.fastItmeconfombtn.btn-comp");
                    $('#date').val($('#fastdate').val());
                $('#time').val($('#fasttime').val());
                
                self.comlpit.find('.btn-confirm').trigger('click');      //예약 완료 진행
            });
            */
            self.$searchCurrentButton.on('click', function(e) {  //내위치 
                self.searchType = 'current';
                self._setCurrentSearch();               
            });
            self.$searchUserAdressButton.on('click', function(e){  //내주소
                self.searchType = 'user';
                self._setUserAdressSearch();
            });

            //seq 있는 경우 탭
            self.$seqTab.vcTab().on('tabchange', function(e, data){

                var tabIdx = data.selectedIndex;
                if(tabIdx==0){
                    //내주소
                    self.$dirTab.hide();
                    self.$searchUserAdressButton.trigger('click');
                }else if(tabIdx==1){
                    //현재위치
                    self.$dirTab.hide();
                    self.$searchCurrentButton.trigger('click');
                }else if(tabIdx==2){
                    self.centerList.find('.no-data').hide(); //주소 미등록 안내 숨김
                    self.$dirTab.show().find('.ui_tab').vcTab("select", 0);
                    self.searchkeyword.val('');
                    self.searcharea.find('.ui_input_clearbutton').trigger('update');
                    self.localSi.prop('selectedIndex', 0).vcSelectbox('update');
                    self.localGu.prop('selectedIndex', 0).prop('disabled', true).vcSelectbox('update');
                    self.$subwayCitySelect.prop('selectedIndex', 0).vcSelectbox('update');
                    self.$subwayLineSelect.prop('selectedIndex', 0).prop('disabled', true).vcSelectbox('update');
                    self.$subwayStationSelect.prop('selectedIndex', 0).prop('disabled', true).vcSelectbox('update');
                }

            });


            //모델입력 앤터 처리
            //BTOCSITE-62364 모델번호, 제조번호 입력
            // self.$modelSearchBox.on('keyup', 'input[id=search]', function(e) {
            //     //영문이나 숫자로 이루어진 모델명을 2자 이상 입력해 주세요.
            //     self.$modelSearchBox.find('.search-error').html('영문이나 숫자로 이루어진 모델명을 2자 이상 입력해 주세요.');
            //     self.$modelSearchBox.find('.search-error').hide();
            //     if (e.keyCode == 13) {  
            //         e.preventDefault();
            //         var chkdata = self.$modelSearchBox.find('.keyword-list').find('li').find('a').attr('data-model-code');
            //         if($('#search').val().toUpperCase() == chkdata){
            //             self.$modelSearchBox.find('.keyword-list').find('li').find('a').trigger('click');                    
            //         }else{
            //             self.$modelSearchBox.find('.search-error').html('"'+$('#search').val().toUpperCase()+'"에 대한 검색 결과가 없습니다.')
            //             self.$modelSearchBox.find('.search-error').show();
            //         }
            //     }
            // });
            // self.$modelSearchBox.find('.btn-search').on('click', function(e){
            //     e.preventDefault();
            //     var chkdata = self.$modelSearchBox.find('.keyword-list').find('li').find('a').attr('data-model-code');
            //     if($('#search').val().toUpperCase() == chkdata){
            //         self.$modelSearchBox.find('.keyword-list').find('li').find('a').trigger('click');                    
            //     }else{
            //         self.$modelSearchBox.find('.search-error').html('"'+$('#search').val().toUpperCase()+'"에 대한 검색 결과가 없습니다.')
            //         self.$modelSearchBox.find('.search-error').show();
            //     }
            // });
            
            
        },
        reset: function() {
                var self = this;
                var $listTable = self.$stepCenter.find('.center-result-wrap .tb_row'),
                    $noData = self.$stepCenter.find('.no-data');

                $listTable.find('tbody').empty();
                $listTable.hide();
                $noData.show();

                self.data = $.extend({}, self.options);

                if(isLogin) { // 모든 약관동의 해제
                        $(".agree-wrap input:checkbox").prop('checked', false);
                        
                        // BTOCSITE-47599 로그인 후, 정보 '선택해 주세요' or '입력해 주세요' 부분 문구 정비
                        $('#saleInfo').find('.tit-wrap .tit').text('제품 구매 정보를 입력해 주세요');
                    }

                self.$myModelWrap.show();
                //BTOCSITE-62364 모델번호, 제조번호 입력
                //모델명/제조번호
                self.delModelValue();
                $('.prod-model-box .btn-prod-next').prop('disabled', true);

                //BTOCSITE-69400 고객지원 > 출장예약 > 구매정보 입력 단계 수정 및 스타일러 도어 대응
                $('#sympCd').val('');
                $('#sympCdNm').val('');
                $('#sympSubCode').val('');
                $('#sympSubCodeNm').val('');
                $('#sympSubCodeNm').val('');
                $('#sympCodeThree').val('');
                $('#sympCodeThreeNm').val('');
                self.$topicList.empty();
                self.$solutionsBanner.hide();

                self.$sub1TopicBox.hide();
                self.$sub1TopicSelect.empty();
                self.$sub1TopicBox.find('.ui-selectbox-list ul').empty();
                
                self.$sub2TopicBox.hide();
                self.$sub2TopicSelect.empty();
                self.$sub2TopicBox.find('.ui-selectbox-list ul').empty();

                // self.$citySelect.find('option:first-child').prop('selected', true);
                // self.$citySelect.vcSelectbox('update');
                // self.$boroughSelect.find('option:first-child').prop('selected', true);
                // self.$boroughSelect.prop('disabled', true).vcSelectbox('update');
                // self.$localSearchButton.prop('disabled', true);
                
                // self.$subwayCitySelect.find('option:first-child').prop('selected', true);
                // self.$subwayCitySelect.vcSelectbox('update');
                // self.$subwayLineSelect.find('option:first-child').prop('selected', true);
                // self.$subwayLineSelect.prop('disabled', true).vcSelectbox('update');
                // self.$subwayStationSelect.find('option:first-child').prop('selected', true);
                // self.$subwayStationSelect.prop('disabled', true).vcSelectbox('update');
                // self.$searchSubwayButton.prop('disabled', true);

                // self.$citySelect2.find('option:first-child').prop('selected', true);
                // self.$citySelect2.vcSelectbox('update');
                // self.$address1.val('');//.prop('disabled', true); // BTOCSITE-22125 센터 검색 기능 추가

                //self.$cont.find('.ui_tab').vcTab('select', 0);
                
                $('#buyingdate').val('');
                $('#engineerNm').val('');
                $('#engineerCode').val('');
                $('#centerNm').val('');
                $('#centerCode').val('');
                $('#seq').val('');
                $('#lockId').val('');
        
                self.$stepInput.find('[name=buyingdate]').closest('.conts').find('.form-text').remove();
                self.$stepInput.find('[name=buyingdate]').prop('checked', false);
                self.$stepInput.find('#content').val('');

                if (!isLogin) {
                    self.$stepInput.find('#userNm').val('');
                    self.$stepInput.find('#phoneNo').val('');
                    
                }
                $('#agreeToTerms').find('.btn-group').show();
                
                
                self.$stepDate.removeClass('active');
                self.$stepCenter.removeClass('active');
                self.$prodWrap.show();
                self.$completeBtns.hide();
                self.comlpit.hide();

                validation.reset();
                self.$dateWrap.calendar('reset');
                self.$timeWrap.timeCalendarNew('reset').hide();

                self.pSi = ''
                self.pGu = ''
                self.latitude = '';
                self.longitude = '';
                self.searchkeyword.val('');
                self.localSi.prop('selectedIndex', 0).vcSelectbox('update');
                self.localGu.prop('selectedIndex', 0).prop('disabled', true).vcSelectbox('update');
                self.$subwayCitySelect.prop('selectedIndex', 0).vcSelectbox('update');
                self.$subwayLineSelect.prop('selectedIndex', 0).prop('disabled', true).vcSelectbox('update');
                self.$subwayStationSelect.prop('selectedIndex', 0).prop('disabled', true).vcSelectbox('update');

                self.$cont.find('.ui_input_clearbutton').trigger('update');
                self.$cont.find('.ui_all_checkbox').vcCheckboxAllChecker('setAllNoneChecked');
                self.$cont.find('.ui_textcontrol').trigger('textcounter:change', { textLength: 0 });
        },
        _getKeyword: function(){
                var self = this;
                var keywords = {};

                switch(self.searchType) {
                    case 'local':
                        keywords = {
                            latitude:self.latitude,
                            longitude:self.longitude,
                            pSi:self.pSi,
                            pGu:self.pGu
                        };    
                        break;
                    case 'current':
                        keywords = {
                            latitude:self.latitude,
                            longitude:self.longitude
                        };
                    case 'road':
                        keywords = {
                            latitude:self.latitude,
                            longitude:self.longitude
                        };
                        break;
                    case 'user':
                        keywords = {
                                latitude:self.latitude,
                                longitude:self.longitude
                                //searchKeyword: self.localSi.val() + self.localGu.val(),
                                //naverSearch: "Y"
                        };
                        break;
                    case 'center':
                        keywords = {
                                //searchCity: self.$citySelect2.val(),
                                searchKeyword: self.searchkeyword.val(),
                                naverSearch: "Y"
                        };
                        break;
                    case 'subway':
                        keywords = {
                                searchSubwayLocal: self.$subwayCitySelect.val(),
                                searchSubwayLine: self.$subwayLineSelect.val(),
                                searchSubwayStation: self.$subwayStationSelect.val()
                        };
                        break;
                };

                // //console.log("keywords :", keywords)

                return keywords;
        },
        setTopicList: function(data) {
            var self = this;
            var html;
            var success = (data.topicList instanceof Array && data.topicList.length) ? true : false;

            if (success) {
                html = vcui.template(topicTmpl, data);
                self.$topicList.html(html);
            }
        },
        requestSub1Topic: function(url, param) {
            var self = this;

            lgkorUI.showLoading();
            lgkorUI.requestAjaxData(url, param, function(result) {
                var data = result.data,
                    html;
                html = vcui.template(sub1TopicTmpl, data);

                self.$subTopicWrap.show();
                self.$sub1TopicBox.show();
                self.$sub1TopicSelect.html(html);
                self.$productProblemsBox.find('#sub-topic-msg').hide();
                self.$sub1TopicSelect.vcSelectbox('update');

                self.$sub1TopicBox.find('.ui-selectbox-wrap').find('.ui-select-button').trigger('click'); // 증상2 자동 열림
                self.$sub1TopicBox.find('.ui-selectbox-list').show();

                lgkorUI.hideLoading();
            });
        },
            
        requestSub2Topic: function(url, param) {
            var self = this;

            lgkorUI.showLoading();
            lgkorUI.requestAjaxData(url, param, function(result) {
                var data = result.data,
                    html;
                html = vcui.template(sub2TopicTmpl, data);
                
                self.$sub2TopicBox.show();
            
                self.$sub2TopicSelect.html(html);
                self.$productProblemsBox.find('#three-topic-msg').hide();
                self.$sub2TopicSelect.vcSelectbox('update');

                
                //BTOCSITE-59670 고객지원 > 증상 선택시 2depth와 3depth 동일 증상이면 선택 예외처리 요청
                var timeout = null;
                var arr = data.threeTopicList;
                if(Object.keys(arr).length === 1) {
                    self.$sub2TopicSelect.vcSelectbox('selectedIndex', 1, true);
                    
                    clearTimeout(timeout);
                    timeout = setTimeout(function() {
                        self.$sub2TopicSelect.vcSelectbox('update');	
                        self.$sub2TopicSelect.trigger('click');
                    }, 10);
                }

                self.$sub2TopicBox.find('.ui-selectbox-wrap').find('.ui-select-button').trigger('click'); // 증상2 자동 열림
                self.$sub2TopicBox.find('.ui-selectbox-list').show();
                lgkorUI.hideLoading();
            });
        }, 
        requestSolutions: function(url, param) {
            var self = this;

            lgkorUI.showLoading();
            lgkorUI.requestAjaxData(url, param, function(result) {          
                var data = result.data;

                if (data.resultFlag == 'Y') {
                    self.$solutionsBanner.show();
                    self.requestQna();
                    lgkorUI.scrollTo($('#addDesc'));
                }else{
                    self.$solutionsBanner.hide();
                }
                
                lgkorUI.hideLoading();
            });
        },
        //BTOCSITE-90818 고객지원 > 서비스 센터 > 스스로해결 콘텐츠 노출
        requestQna: function() {
            var $chatWrap = $('#solutionBanner');
            var url = $chatWrap.data('solutionListUrl');
            var param = {
                sympCd: $('input[name=sympCd]:checked').val(),
                sympSubCode: $('#sTopic01Select option:selected').val(),
                sympCodeThree: $('#sTopic02Select option:selected').val(),
                productCode: $('#productCode').val(),
            };

            lgkorUI.requestAjaxData(url, param, function(result){
                var data = result.data;
                var $qnaWrap = $chatWrap.find('.qna-list');
                var $solutionPopup = $('#solutionsPopup');

                if (data.resultFlag == 'Y'){
                    var qnaTmpl = 
                        '<dt>Q&amp;A를 보고 해결하기</dt>' +
                        '{{#each (item, index) in resultList}}' +				
                        '<dd><span class="blind">질문</span><button type="button" data-href="#solutionsPopup" data-item-id="{{item.itemId}}">{{ item.dpItemTitle}}</button></dd>'+
                        '{{/each}}';
                        
                    var html = vcui.template(qnaTmpl, data);
                    
                    $qnaWrap.find('dl').empty().html(html); 
                    $qnaWrap.show();

                    //solutionsPopup
                    var qnaPopTmpl = "";
                    for(var i=0; i < data.resultList.length ; i++){
                        qnaPopTmpl += '<div class="qna-cont" data-item-id="'+ data.resultList[i].itemId +'" style="display:none;">'+data.resultList[i].dpItemContents +'</div>'
                    }
                    $solutionPopup.find('.pop-conts').empty().html(qnaPopTmpl); 
                    
                } else {
                    $qnaWrap.hide();
                }
    
            },"GET", null, true);
        },
        searchAddressToCoordinate: function(address, callback) { 
            var self = this;
            
            naver.maps.Service.geocode({
            address: address
            }, function(status, response) {

            if (status === naver.maps.Service.Status.ERROR) {
                return alert('Something Wrong!');
                
            }
            
            var point = response.result.items[0].point;
            self.longitude = point.x;
            self.latitude = point.y;

            callback && callback();
            });
        },
        _loadLocalAreaList: function(val){
            var self = this;
            lgkorUI.requestAjaxData(self.localUrl, {pcode:encodeURI(val),codeType:'CITY'}, function(result){
                var arr = result.data instanceof Array ? result.data : [];
                
                self._setSubwayOption(result.data, self.localGu, {codeName:"구/군 선택", code:""}, "code");
                self.localSearchButton.prop('disabled', false);
                self.localGu.prop('disabled', arr.length ? false : true);
                self.localGu.vcSelectbox('update');
                
                $('#mapSelect2Box').find('.ui-selectbox-wrap').addClass('active'); // 서브 카테고리 자동 열림
                $('#mapSelect2Box').find('.ui-selectbox-wrap').addClass('on'); // 서브 카테고리 자동 열림
                $('#mapSelect2Box').find('.ui-selectbox-list').show();
            });
        },
        _setSubwayOption: function(result, select, firstdata, valuekey){
            var self = this;
            var lines = vcui.array.map(result, function(item, idx){
                return {
                    codeName: item.codeName,
                    code: item[valuekey]
                }
            });
            lines.unshift(firstdata);
            self._setSelectOption(select, lines);
            select.vcSelectbox('update');
        },

        _setSelectOption: function(select, list){
            var self = this;

            select.empty();

            for(var i in list){
            var opt = vcui.template(localOptTemplate, list[i]);
            select.append($(opt).get(0));
            }
        },
        //지역 검색...
        _setLocalSearch: function(){
            var self = this;
            
            var keyword = self.localSi.val() + ' ' + self.localGu.val();
            var trim = keyword.replace(/\s/gi, '');
            if(trim.length){
                var callback = function() {
                    self.requestCenterData()
                };
            
                self.searchResultMode = true;
                self.schReaultTmplID = "localSearch";
                self.pSi =self.localSi.val();
                self.pGu = self.localGu.val();
                
                self.searchAddressToCoordinate(trim, callback);
            }
        },
       
        // 내 주소로 검색....
        _setUserAdressSearch: function(){
        
            var self = this;
            lgkorUI.requestAjaxDataIgnoreCommonSuccessCheck(self.userAdressCheckedUrl, {}, function(result){
                var data = result.data;
                if(lgkorUI.stringToBool(data.success)){
                var callback = function() {
                        self.requestCenterData()
                };

                self.searchResultMode = true;
                self.schReaultTmplID = "localSearch";

                self.searchAddressToCoordinate(data.userAdress, callback);
                } else{
                if(data.location && data.location != ""){
                        lgkorUI.confirm('로그인을 하셔야 이용하실 수 있습니다. <br>로그인 하시겠습니까?',{
                            typeClass:'type2',
                            title:'',
                            okBtnName: '네',
                            cancelBtnName: '아니요',
                            ok: function() {
                            location.href = data.location;
                            }
                        }, self.$searchUserAdressButton[0]);
                } else{

                    self.centerList.find('.list-wrap').hide();
                    self.centerList.find('.no-data').show().find('p').html(data.alert.title);

                    // lgkorUI.alert("", {
                    //     title: data.alert.title
                    // }, self.$searchUserAdressButton[0]);
                }
                }
            });
        },
       
        
        
        // 현재 위치 검색
        _setCurrentSearch: function() {
            var self = this;
            var opener = self.$searchCurrentButton[0];
            var searchCurrentSearch = function() {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function(pos) {
                        self.latitude = pos.coords.latitude;
                        self.longitude = pos.coords.longitude;
        
                        self.searchResultMode = true;
                        self.schReaultTmplID = "localSearch";
                            
                        cookie.setCookie('geoAgree','Y', 1);

                        self.requestCenterData();
                    }, function(error) {
                        lgkorUI.alert('현재 위치를 찾을 수 없습니다.', {
                            title: '현재 위치 정보',
                            typeClass: 'type2'
                        }, opener);
                    }); 
                } else {
                    lgkorUI.alert('위치 기반 서비스를 제공하지 않습니다.', {
                        title: '현재 위치 정보',
                        typeClass: 'type2'
                    }, opener);
                }
            };
            var obj ={
                title:'센터찾기 위치 정보 수집 이용 동의', 
                typeClass:'type2', 
                okBtnName: '동의',
                cancelBtnName: '동의 안함',
                ok : function (){
                    searchCurrentSearch();
                },
                cancel: function() {
                    lgkorUI.alert('현재 위치를 찾을 수 없습니다.', {
                        title: '현재 위치 정보',
                        typeClass: 'type2'
                    }, opener);
                }};
                // BTOCSITE-34955 위치정보 제공 동의서 수정 및 링크 추가 요청 건
                var desc = '<p style="text-align:left;">LG전자 주식회사(이하 &apos;회사&apos;라 합니다)는 고객님께서 현재 계신 위치에서 직선 거리 기준으로 가장 가까운 센터를 안내하기 위하여 위치정보를 수집하고 있습니다. <br><br>또한 상기 서비스 제공 후 즉시 폐기되며, 별도 저장되지 않습니다.<br><br>본 서비스 이용을 위해서는 <a href="https://kr.m.lgaccount.com/customer/terms_detail?country=KR&language=ko-KR&terms_svcCode=SVC709&terms_type=A_ITG_LBS&terms_publish=Y&division=noticeterms" style="text-decoration: underline;" target="_blank" data-app-target="out">&apos;LG전자 위치기반서비스 이용약관&apos;</a>의 동의가 필요합니다.<br><br>고객님의 현재 계신 위치 정보 제공 및 LG전자 위치기반서비스 이용약관에 동의하시겠습니까?</p>';
                    
            if (!cookie.getCookie('geoAgree')) {
                lgkorUI.confirm(desc, obj, opener);
            } else {
                searchCurrentSearch();
            }
        },

        // 지하철역 검색...
        _setSubwaySearch: function(){
            var self = this;
            var keyword = self.$subwayStationSelect.val();
            var trim = keyword.replace(/\s/gi, '');
            if(trim.length){
                self.schReaultTmplID = "subwaySearch";
                self.searchResultMode = true;
            
                self.requestCenterData();
            } else{
                lgkorUI.alert("", {
                    title: "지하철 검색의 역명을 선택해 주세요."
                });
            }
        },

        // 센터명 검색...
        _setSearch: function(){
            var self = this;
            
            var keyword = self.searchkeyword.val();
            var trim = keyword.replace(/\s/gi, '');
            if(trim.length){
                // BTOCSITE-22125 센터 검색 기능 추가
                // var callback = function() {
                    self.requestCenterData()
                // };

                //self.schReaultTmplID = "search";
                //self.searchResultMode = true;

                //$(window).off('keyup.searchShop');

                // BTOCSITE-22125 센터 검색 기능 추가
                // self.searchAddressToCoordinate(self.$citySelect2.val(), callback);
            //}
            // BTOCSITE-22125 센터 검색 기능 추가
            } else{
                lgkorUI.alert("", {
                    title: "검색어를 입력해 주세요."
                });
            }
        },
        setWarranty: function(data) {
                var self = this;
                var $warranty = self.$stepInput.find('[name=buyingdate]');
                
                if (isLogin) {
                    if (!!data.warrantyText && data.warrantValue.toString()) {
                    $warranty.closest('.conts').append('<p class="form-text">'+data.warrantyText+'</p>');
                    $warranty.filter('[value='+data.warrantValue+']').prop('checked', true);
                    
                    $warranty.closest('.rdo-list-wrap').hide();
                    } else {
                    $warranty.closest('.rdo-list-wrap').show();
                    }
                }
        },
        //센타 목록조회
        requestCenterData: function(options, url) {
            var self = this;
            var param = self._getKeyword();
            var url = url || self.centerUrl;

            if (!options) {
                var options = {
                    page:1
                };
            }
            options = $.extend(true, options, {productCode:$('#productCode').val()});
            param = $.extend(true, param, options);
            
            lgkorUI.showLoading();
            lgkorUI.requestAjaxDataPost(url, param, function(result) {
                var data = result.data,
                    dataArr = data.seqFindCenter.listData instanceof Array ? data.seqFindCenter.listData : [],
                    html = "";

                var $listTable = $('#centerList'),
                    $list = $listTable.find('.list-wrap'),
                    $seqVisit = $('#seqVisit');
                    $noData = self.$stepCenter.find('.no-data');

                var centerNum = 0;
                if(param.seq){
                    dataArr = data.seqFindCenter;
                    dataArr.listData = data.seqFindCenter;
                }

                
                $list.find('ul').empty();
                if (dataArr.length > 0) {
                    
                    $noData.hide();
                    $list.hide();
                    
                    if(param.seq){
                        if(typeof dataArr[0].resrvDt != 'undefined'){
                            //방문예약 가능
                            html = vcui.template(centerTmpl2, data.seqFindCenter);
                            $seqVisit.show().find('ul').empty().html(html).find('li').show();
                            $seqVisit.find('.text').hide();

                            setTimeout(function(){
                                $seqVisit.find('.btn.border').click();
                            }, 100);

                        }else{
                            //방문예약 불가능
                            html = vcui.template(centerTmpl2, data.seqFindCenter);
                            $seqVisit.show().find('ul').empty().html(html).find('li').show();
                        }

                         //내 주소
                        myAddrArr = data.myAddrNearCenter === '' ? [] : data.myAddrNearCenter.listData instanceof Array ? data.myAddrNearCenter.listData : [];
                        if(myAddrArr.length > 0){
                            html = vcui.template(centerTmpl2, data.myAddrNearCenter);
                            $list.show().find('ul').html(html);

                        }else{
                           self.$seqTab.vcTab("select", 0);
                        } 
                        // seqTab 탭
                        self.$seqTab.find('li').removeClass('on').eq(0).addClass('on');
                        self.$dirTab.hide();

                    }else{
                        html = vcui.template(centerTmpl2, data.seqFindCenter);
                        $list.show().find('ul').html(html);

                        if(self.seqFlag){
                            $seqVisit.find('ul li').removeClass('on');
                        }
                    }
                    
                    //centerSort 관련
                    $listTable.find('input[name=centerSort]').prop('checked', true); //예약 가능 센터만 보기
                    var totalLength = $list.find('li').length;
                    var disLength = $list.find('button:disabled').length;
                    if(totalLength === disLength && totalLength > 0) {
                        $noData.show().html('예약 가능한 센터가 없습니다.');
                    }
                    
                    if (data.resultFlag == 'Y') {
                        self.setWarranty(data);
                    }
                    
                }else{
                    $noData.show().find('p').html('검색 결과가 없습니다.');
                    $list.hide();
                }
                self.setTopic(data);

                self.$stepDate.removeClass('active');
                self.$stepInput.removeClass('active');
                
                self.$dateWrap.calendar('reset');
                self.$timeWrap.timeCalendarNew('reset').hide();

                // lgkorUI.hideLoading();
            });

            self.comlpit.hide(); //예약 버튼 비활성화
        },
        setTopic: function(data) {
            var self = this;
            var success = (data.topicList instanceof Array && data.topicList.length) ? true : false;
            
            if (success) {
                self.$topicList.html(vcui.template(topicTmpl, data));
            }
        },
        reqeustSolutions: function(url, param) {
            var self = this;

            lgkorUI.requestAjaxData(url, param, function(result) {
                var data = result.data;
                
                if (data.resultFlag == 'Y') {
                self.$solutionsBanner.show();
                } else {
                self.$solutionsBanner.hide();
                }

                $('#solutionsFlag').val(data.resultFlag);
            });
        },
        setSolutions: function(param, isShown) {
            var self = this;
            var url = self.$solutionsPopup.data('listUrl');

            lgkorUI.requestAjaxData(url, param, function(result){
                self.$solutionsPopup.find('.pop-conts').html(result);
                self.$solutionsPopup.find('.pagination').pagination();
                
                if (isShown) {
                self.$solutionsPopup.find('.ui_accordion').vcAccordion();
                } else {
                self.$solutionsPopup.vcModal();
                }

                self.$solutionsPopup.find('.pagination').on('pageClick', function(e) {
                var param = {
                            topic : $('input[name=topic]:checked').val(),
                            subToic : $('input[name=subTopic]:checked').val(),
                            productCode : $('#productCode').val(),
                            page: e.page
                        };

                self.setSolutions(param, true);
                });
            }, null, "html", true);
        },
        requestDate: function(pageType) {
            var self = this;
            var data = self.data;
            var param = {
                category: $('#category').val(),
                subCategory: $('#subCategory').val(),
                productCode: $('#productCode').val(),
                serviceType: $('#serviceType').val(),
                lockId: $('#lockId').val(),
                deptCode: $('#deptCode').val()
            };
            
            lgkorUI.showLoading();
            lgkorUI.requestAjaxDataPost(self.dateUrl, param, function(result) {
                var data = result.data,
                    dateArr = data.dateList instanceof Array ? data.dateList : [],
                    fastDate;
            
            
                if (data.resultFlag == 'Y') {
                    if (dateArr.length) {
                        fastDate = dateUtil.format(data.fastDate + '' + data.fastTime + '00', 'yyyy.MM.dd hh:mm');
                            
                        $('#stepArea').find('.info-wrap .reser-info .point').html(fastDate);
                        $('#fastdate').val(data.fastDate);
                        $('#fasttime').val(data.fastTime);
                        
                        //self.$stepDate.find('.calendar-info .date').html(fastDate);    
                        self.$dateWrap.calendar('update', data.dateList);
                        self.data = $.extend(self.data, result.param);
            
                        if(pageType == "reservation") self.$stepDate.addClass('active');//.attr('tabindex', '0').focus().removeAttr('tabindex');
                        //self.$stepDate.addClass('active').attr('tabindex', '0').focus().removeAttr('tabindex');
            
                        self.$timeWrap.timeCalendarNew('reset').hide();
                        self.$stepInput.removeClass('active');
                        
                        
                        //self.fastItmeconfom.show().addClass('active');//가장 빠른 일시 선택 창
                        //self.fastItmeconfombtn.show();//확정및 일자 선택 관련 버튼
                        self.$stepDate.addClass('active');
                        //lgkorUI.scrollTo($(self.fastItmeconfom));
                        

                        //BTOCSITE-79146 고객지원 > 센터방문예약> 프로세스 개선
                        //seq 일때 이동하지 않음
                        // if(!self.seqFlag){
                        //     lgkorUI.scrollTo(self.$stepDate);
                        // }
                        
                        //self.$completeBtns.hide();
                    }else{
                        //데이터가 없을 경우 가장빠른일시 숨김
                        //self.fastItmeconfom.hide().removeClass('active');       //가장 빠른 일시 선택 창
                        //self.fastItmeconfombtn.hide();    //확정및 일자 선택 관련 버튼
                        self.$stepDate.removeClass('active');
                        //self.fastItmeconfom.hide();
                    }
                } else {
                    if (data.resultMessage) {
                        if (data.tAlert == 'Y') {
                            self.$stepInput.find('.step-btn-wrap').show();
                            self.$stepDate.removeClass('active');
                        }
            
                        lgkorUI.alert("", {
                            title: data.resultMessage
                        });
                    }
                    //self.fastItmeconfom.hide();
                    self.$stepDate.removeClass('active');
                    self.$stepInput.removeClass('active');
                    //self.$completeBtns.hide();
            
                    self.$dateWrap.calendar('reset');
                    self.$timeWrap.timeCalendarNew('reset').hide();
                }
            
                lgkorUI.hideLoading();
            });
        },
        requestTime: function() {
            var self = this;
            var data = self.data;
            var param = {
                category: $('#category').val(),
                subCategory: $('#subCategory').val(),
                productCode: $('#productCode').val(),
                serviceType: $('#serviceType').val(),
                deptCode: $('#deptCode').val(),
                lockUserId: $('#lockUserId').val(),
                date: $('#date').val()               
            };

            lgkorUI.showLoading();
            lgkorUI.requestAjaxData(self.timeUrl, param, function(result) {
                var data = result.data;

                if (data.resultFlag == 'Y') {
                self.$timeWrap.timeCalendarNew('update', data.timeList).show();
                self.$timeWrap.find('.box-desc').hide();
                self.$timeWrap.find('.box-table').show();
                } else {
                if (data.resultMessage) {
                        if (data.tAlert == 'Y') {
                            self.$stepDate.removeClass('active');
                            self.$completeBtns.hide();
                        }
                        
                        lgkorUI.alert("", { title: data.resultMessage });
                }
                }

                self.$stepInput.removeClass('active');
                self.$completeBtns.hide();

                lgkorUI.hideLoading();
            }, 'POST');
        },
        reqestEngineer: function() {
            var self = this;
            var data = self.data,
                param = {
                category: $('#category').val(),
                subCategory: $('#subCategory').val(),
                productCode: $('#productCode').val(),
                serviceType: $('#serviceType').val(),
                deptCode:  $('#deptCode').val(),
                lockUserId: $('#lockUserId').val(),
                lockId: $('#lockId').val(),
                date: $('#date').val(),
                time:$('#time').val()        
                };
            
            lgkorUI.showLoading();
            lgkorUI.requestAjaxDataPost(self.engineerUrl, param, function(result) {
                var data = result.data;
                // arr = data.engineerList instanceof Array ? data.engineerList : []; 
                // var slideConfig = {
                // slidesToShow: 4,
                // slidesToScroll: 4,
                // responsive: [
                //         {
                //             breakpoint: 10000,
                //             settings: {
                //             slidesToShow: 4,
                //             slidesToScroll: 4,
                //             }
                //         },
                //         {
                //             breakpoint: 1024,
                //             settings: {
                //             slidesToShow: 3,
                //             slidesToScroll: 3,
                //             }
                //         },
                //         {
                //             breakpoint:767,
                //             settings: {
                //             variableWidth : true,
                //             slidesToShow: 1,
                //             slidesToScroll: 1
                //             }
                //         }
                // ]
                // };

              

                if (data.resultFlag == 'Y') {  
                    var data = result.data;
                    $('#lockId').val(result.lockId);
                // if (arr.length) {
                //         self.updateEngineer(arr[0]);
                //         if (arr.length > 1) {
                //             self.$engineerResult.find('.btn').show();
                //         } else {
                //             self.$engineerResult.find('.btn').hide();
                //         }
                //         self.$stepInput.addClass('active');
                //         self.$completeBtns.show();
                // }

                    self.comlpit.show();
                }else{
                    if (data.resultMessage) {
                        lgkorUI.alert("", {
                            title: data.resultMessage
                        });
                    }
                }
                lgkorUI.hideLoading();
            });
        },
        updateEngineer: function(data) {
                
            var self = this,
                $engineerBox = self.$engineerResult.find('.engineer-profile'),
                $resultBox = self.$engineerResult.find('.engineer-desc');

            $engineerBox.find('.engineer-img img').attr({
                'src': data.image,
                'alt': data.engineerName + ' 서비스매니저 사진'
            });                             
            $engineerBox.find('.name').html(data.engineerName);
            $engineerBox.find('.center').html(data.centerName);

            // $resultBox.find('.date').html(vcui.date.format($('#date').val() + '' + $('#time').val() + '00', "yyyy.MM.dd hh:mm"));
            // $resultBox.find('.name').html(data.engineerName);

            $('#engineerNm').val(data.engineerName);
            $('#engineerCode').val(data.engineerCode);
            $('#centerNm').val(data.centerName);
            $('#centerCode').val(data.centerCode);

            /* BTOCSITE-7660 고객지원 - 출장/내방/예약변경 시 SE 사진 비노출 요청  */
            // BTOCSITE-22532 [고객지원] 엔지니어 → 서비스매니저 명칭 변경 일괄 진행
            $resultBox.find('.txt').html('<span>'+vcui.date.format($('#date').val() + '' + $('#time').val() + '00', "yyyy.MM.dd hh:mm")+'</span>에 <span>'+data.engineerName+'</span> <span>('+data.centerName+')</span> 서비스매니저가 <span>'+self.data.subCategoryNm+'</span> <span class="bold">제품 점검이 가능합니다.</span><br><br>센터 방문 예약을 완료를 위해 아래 정보를 추가 입력해 주시기 바랍니다.');

            self.data['resrvSeq'] = data.resrvSeq;
            $('#resrvSeq').val(data.resrvSeq);
        },
        requestComplete: function() {
            var self = this;
            
            var url = self.$submitForm.data('ajax');
            var formData = validation.getAllValues();
            formData = $.extend(formData, {
                centerNm: $('#centerNm').val(),
                lockId: $('#lockId').val(),
                date: $('#date').val(),
                time: $('#time').val()
            });
            //로그인 체크
            formData.topLoginFlag = lgkorUI.isLogin ? 'Y' : 'N';
 
            //formData = $.extend(formData, self.data);
            lgkorUI.showLoading();
            lgkorUI.requestAjaxDataPost(url, formData, function(result) {
                var data = result.data;

                // 로그인 체크
                if(data.loginCheckFlag == 'N') {
                    lgkorUI.hideLoading();
                    $('#loginPopup').vcModal();
                    return;
                }

                if (data.resultFlag == 'Y') {
                    $('#acptNo').val(data.acptNo);
                    self.$submitForm.submit();
                } else {
                    lgkorUI.hideLoading();
                    
                    if (data.resultMessage) {
                        lgkorUI.alert("", {
                            title: data.resultMessage
                        });
                    }
                }
            }, 'POST');
        }
    }

    $(window).ready(function() {
        reservation.init();
        if($('#preLoad').val() == "Y"){
            $('div.section.accord-wrap.prod-selected-box.prod-search-wrap').hide();
        }
        $(".list-item").on('click', '.store-info-list', function(e) {
                e.preventDefault();      
                reservation.requestDate("reservation");
        });
    });

    window.addEventListener("message", function(e) {
        //상세정보 팝업에서 방문예약 선택시
        if(e.origin === vcui.uri.getHost() && e.data.length < 5) {
            $('.center-result-wrap').find('li[data-id="'+e.data+'"]').find('.center-info').trigger('click');
        }
    });
 })() 